import axios from 'axios';

// Load variables from localStorage
export const loadVariableSettings = () => {
    const savedVariables = localStorage.getItem('variableSettings');
    if (savedVariables) {
        return JSON.parse(savedVariables);
    }
    
    // Default variables if none are saved
    const defaultVariables = [
        { id: "year", label: "Year", showInPopup: true, showInTrends: false },
        { id: "state_county", label: "State/County FIPS", showInPopup: false, showInTrends: false },
        { id: "avg_ann_income_indv", label: "Average Individual Income", showInPopup: false, showInTrends: true },
        { id: "avg_mortgage_payment", label: "Average Mortgage Payment", showInPopup: false, showInTrends: false },
        { id: "avg_ann_income_family", label: "Average Family Income", showInPopup: true, showInTrends: true },
        { id: "indv_no_foodstamps_percent", label: "Individuals Not on Food Stamps %", showInPopup: false, showInTrends: false },
        { id: "indv_foodstamps_percent", label: "Individuals on Food Stamps %", showInPopup: false, showInTrends: false },
        { id: "females_percent", label: "Female %", showInPopup: true, showInTrends: true },
        { id: "males_percent", label: "Male %", showInPopup: true, showInTrends: true },
        { id: "widowed_percent", label: "Widowed %", showInPopup: false, showInTrends: false },
        { id: "never_married_percent", label: "Never Married %", showInPopup: false, showInTrends: false },
        { id: "married_spouse_present_percent", label: "Married (Spouse Present) %", showInPopup: false, showInTrends: false },
        { id: "divorced_percent", label: "Divorced %", showInPopup: false, showInTrends: false },
        { id: "separated_percent", label: "Separated %", showInPopup: false, showInTrends: false },
        { id: "married_spouse_absent_percent", label: "Married (Spouse Absent) %", showInPopup: false, showInTrends: false },
        { id: "white_percent", label: "White %", showInPopup: false, showInTrends: false },
        { id: "black_percent", label: "Black %", showInPopup: false, showInTrends: false },
        { id: "other_race_percent", label: "Other Race %", showInPopup: false, showInTrends: false },
        { id: "two_minor_race_percent", label: "Two or More Races %", showInPopup: false, showInTrends: false },
        { id: "japanese_percent", label: "Japanese %", showInPopup: false, showInTrends: false },
        { id: "other_asian_percent", label: "Other Asian %", showInPopup: false, showInTrends: false },
        { id: "american_indian_alaska_native_percent", label: "American Indian/Alaska Native %", showInPopup: false, showInTrends: false },
        { id: "chinese_percent", label: "Chinese %", showInPopup: false, showInTrends: false },
        { id: "three_plus_races_percent", label: "Three or More Races %", showInPopup: false, showInTrends: false },
        { id: "citizen_percent", label: "Citizens %", showInPopup: true, showInTrends: true },
        { id: "non_citizen_percent", label: "Non-Citizens %", showInPopup: false, showInTrends: false },
        { id: "naturalized_citizen_percent", label: "Naturalized Citizens %", showInPopup: false, showInTrends: false },
        { id: "english_at_home_percent", label: "English at Home %", showInPopup: false, showInTrends: false },
        { id: "other_lang_at_home_percent", label: "Other Language at Home %", showInPopup: false, showInTrends: false },
        { id: "some_college_or_bachelor_percent", label: "Some College/Bachelor's %", showInPopup: true, showInTrends: true },
        { id: "high_school_or_lower_education_percent", label: "High School or Lower Education %", showInPopup: true, showInTrends: true },
        { id: "masters_or_professional_cert_percent", label: "Masters/Professional Certification %", showInPopup: false, showInTrends: false },
        { id: "doctoral_degree_percent", label: "Doctoral Degree %", showInPopup: false, showInTrends: false },
        { id: "employed_percent", label: "Employed %", showInPopup: true, showInTrends: true },
        { id: "not_in_labor_force_percent", label: "Not in Labor Force %", showInPopup: false, showInTrends: false },
        { id: "unemployed_percent", label: "Unemployed %", showInPopup: false, showInTrends: false },
        { id: "winner", label: "Election Winner", showInPopup: false, showInTrends: false }
    ];
    
    localStorage.setItem('variableSettings', JSON.stringify(defaultVariables));
    return defaultVariables;
};

// Save variables to localStorage
export const saveVariableSettings = (variables) => {
    localStorage.setItem('variableSettings', JSON.stringify(variables));
}; 